import type { IconData } from '@stacksjs/iconify-core'

export const expandLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464 16h32v480h-32zm-320 0H16v480h128Zm-32 448H48V48h64ZM416 96h-37.86L208.776 255.923L376.079 416H416Zm-32 283.291L255.224 256.077L384 134.478Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default expandLeft
